import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n);

const messages = {
    en: require("./lang/en.json"),
    ru: require("./lang/ru.json"),
};

export let langLoad = false;

const i18n = new VueI18n({
    locale: 'ru',
    fallbackLocale: 'ru',
    messages
})

export default i18n;

export const loadedLanguages: any[] = []

export function setI18nLanguage(lang: any): any {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html')?.setAttribute('lang', lang)

    return lang
}

export function loadLanguageAsync (lang: string): Promise<void> {
    if (loadedLanguages.includes(lang)) {
        if (i18n.locale !== lang) {
            setI18nLanguage(lang)
            langLoad = true;
        }

        return Promise.resolve()
    }

    return axios
            .get(`/public-api/v1/lang/${lang}`)
            .then(response => {
                const msgs = { ...messages[lang as keyof typeof messages], ...response.data }
                loadedLanguages.push(lang)

                i18n.setLocaleMessage(lang, msgs)

                setI18nLanguage(lang);
                langLoad = true;
            }
        )
}
